import { useState, useLayoutEffect } from "react";
import { Button } from "@douyinfe/semi-ui";
import { useNavigate } from "react-router-dom";
import logoImg from "@assets/home-image/logo.svg";
import globalIcon from "@assets/home-image/global.png";
import { RootState, AppDispatch } from "@state/store";
import { useSelector, useDispatch } from "react-redux";
import { headerConfig } from "@services/home/config/home.config";
import { setLang } from "@state/home/reducer";
import { HeaderLanModel } from "@services/home/model/home.model";
import styles from "./index.module.css";

const HomeHeader = () => {
  const lang = useSelector((state: RootState) => state.home.lang);
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const [config, setConfig] = useState<HeaderLanModel>();

  function onChangeLan() {
    if (lang === "en") {
      dispatch(setLang("cn"));
    } else {
      dispatch(setLang("en"));
    }
  }

  function login() {
    navigate("/login");
  }

  function applyTrial() {
    navigate("/index/trial");
  }

  useLayoutEffect(() => {
    const userLan = navigator.language;
    const isChinese =
      userLan === "zh-CN" || userLan === "zh" || userLan === "zh-TW";

    if (!lang) {
      dispatch(setLang(isChinese ? "cn" : "en"));
    }
  }, [lang]);

  useLayoutEffect(() => {
    if (lang) {
      setConfig(headerConfig[lang]);
    }
  }, [lang]);

  return (
    <div className={styles.header}>
      {config && (
        <div className={styles.wrapper}>
          <div>
            <a href="https://www.biogeom.com" target="_black">
              <img src={logoImg} />
            </a>
          </div>
          <div className={styles.right}>
            <span onClick={onChangeLan} className={styles.lanWrapper}>
              <img className={styles.globalImg} src={globalIcon} />
              <span style={{ marginLeft: "10px" }}>{config.lan}</span>
            </span>
            <Button
              theme="solid"
              type="primary"
              className={styles.btn}
              onClick={applyTrial}
            >
              {config.applyText}
            </Button>
            <Button
              theme="light"
              type="tertiary"
              className={`reset-btn ${styles.btn}`}
              onClick={login}
            >
              {config.btnText}
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default HomeHeader;
